module.exports = __webpack_public_path__ + "img/fruits-a-coque.108c9634.svg";